var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconForgotPasswordSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 86,
    viewBox: "0 0 106 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jyyby59yjc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s08prvhuha",
    width: "170%",
    height: "170%",
    x: "-35%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.388235294 0 0 0 0 0.549019608 0 0 0 0 0.796078431 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "e0zncr4edb",
    cx: 52,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-404 -372) translate(360 304) translate(45 72)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 64,
    y: 17,
    stroke: "#B6CBEA",
    strokeWidth: 2,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B6CBEA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 19.745L52 54 103 19.745"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B6CBEA",
    strokeWidth: 2,
    d: "M2.645 81L45.82 50.185M59 49L100.963 81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#s08prvhuha)",
    xlinkHref: "#e0zncr4edb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#jyyby59yjc)",
    xlinkHref: "#e0zncr4edb"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5AC692",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M43.839 19.983L51.791 26.919 71.064 6.267"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForgotPasswordSuccess);
export default __webpack_public_path__ + "static/media/icon-forgot-password-success.d270a573e5d20bafe79a4e48f2fb2943.svg";
export { ForwardRef as ReactComponent };